import http from '../http';

// 获取预订单和房间信息
const fetchSettledBillList = (params) => {
  return http({
    url: `/settlements/${params.resvNo}`,
  });
};

// 取消预订、退房
const submitRevSettle = (data) => {
  return http({
    url: '/settlements/recover',
    method: 'POST',
    data,
  });
};

export { fetchSettledBillList, submitRevSettle };
